module.exports = __webpack_public_path__ + "static/young-leader-photo-aryeh_bookbinder-496f6edf0fe65b43df1269a759cd3042.jpg";